function ControlTestimonies() {
    const classItem = 'block-testimonies__list__item';
    const classClose = 'block-testimonies__list__item__close';
    const classItemActive = `${classItem}--active`;
    const classBG = 'block-testimonies__bg';
    const classBGActive = `${classBG}--active`;
    const animations = {

    };
    let lastVideo;
    let lastIdElement;
    function init() {
        initLoad();
        addListenerItems();
        activeSlider();
        jQuery(window).on("scroll", validateIfTestimonies);
        validateIfTestimonies();
    }
    function initLoad() {
        const list = jQuery('.block-testimonies__list__row');
        for (const iterator of list) {
            const element = jQuery(iterator);
            const key = element.attr('id');
            animations[key] = {
                inPlay: false,
            }
        }
    }
    function validateIfTestimonies() {
        const list = jQuery('.block-testimonies__list__row');
        const top = window.scrollY;
        for (const iterator of list) {
            const element = jQuery(iterator);
            const key = element.attr('id');
            const animation = animations[key];
            if (animation.inPlay) {
                continue;
            }
            const rect = element.offset();
            const height = element.height();
            const start = rect.top - height / 2;
            const end = rect.top + height;
            if (start <= top && end >= top) {
                animation.inPlay = true;
                //element.slick('slickPlay');
            }
        }
    }
    function activeSlider() {
        jQuery('.block-testimonies__list__row').slick({
            slidesToScroll: 1,
            autoplay: false,
            centerMode: true,
            centerPadding: '60px',
            autoplaySpeed: 4000,
            arrows: true,
            pauseOnHover: true,
            mobileFirst: true,
            nextArrow: `<button class='u-slick-next  u-slick-next--out u-slick-arrow'><i class="fa-solid fa-chevron-right"></i></button>`,
            prevArrow: `<button class='u-slick-prev u-slick-prev--out u-slick-arrow'><i class="fa-solid fa-chevron-left"></i></button>`,
            responsive: [
                {
                    breakpoint: 2500,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                    }
                },
                {
                    breakpoint: 1900,
                    settings: {
                        //slidesToShow: 3,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        //centerPadding: '300px',
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        centerPadding: false
                    }
                },
            ]
        });
    }
    function addListenerItems() {
        activeItems();
        removeActiveItems();
        activeViewMore();
    }
    function removeActiveItems() {
        jQuery('.block-testimonies__bg').on('click', function () {
            const idElement = jQuery(this).data('element');
            closeSection(idElement);
        })
        jQuery(`.${classClose}`).on('click', function () {
            const idElement = jQuery(this).data('element');
            closeSection(idElement);
        });
    }
    function closeSection(idElement) {
        const item = jQuery(`#${idElement}`);
        item.removeClass(classItemActive);
        jQuery(`.${classItem}`).removeClass(classItemActive);
        jQuery(`.${classBG}`).removeClass(classBGActive);
        const video = item.find('.block-testimonies__list__item__video')[0];
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
        if (lastVideo) {
            lastVideo.pause();
            lastVideo.currentTime = 0;
        }
    }
    function activeViewMore() {
        jQuery('.block-testimonies__btn-view-more').on('click', function (evt) {
            const btn = jQuery(this);
            const idElement = btn.data('row');
            const classItemHidden = 'block-testimonies__list__item--hidden';
            jQuery(`#${idElement} .${classItemHidden}`).removeClass(classItemHidden);
            btn.remove();
        })
    }
    function activeItems() {
        jQuery(`.block-testimonies__list__item`).on('click', function (evt) {
            const element = evt.target;

            if (jQuery(element).hasClass('block-testimonies__list__item__close')) {
                return;
            }
            if (lastVideo && !lastVideo.paused) {
                lastVideo.pause();
            }
            else {
                const item = jQuery(this);
                item.addClass(classItemActive);
                const idElement = item.attr('id');
                const idBG = item.data('bg');
                const contentBG = jQuery(`#${idBG}`);
                contentBG.data('element',)
                contentBG.addClass(classBGActive);
                const video = item.find('.block-testimonies__list__item__video')[0];
                const jQueryVideo = jQuery(video);
                const urlVideo = jQueryVideo.data('video');
                jQueryVideo.attr('src', urlVideo);


                if (video) {
                    lastVideo = video;
                    //stopLastVideo();
                    lastIdElement = idElement;

                    setTimeout(() => {
                        video.play();
                        window.addEventListener('click', stopLastVideo);
                    }, 10);
                }
            }

        });
    }
    function stopLastVideo() {
        window.removeEventListener('click', stopLastVideo);
        if (lastIdElement) {
            closeSection(lastIdElement);
        }

    }

    init();
}
new ControlTestimonies();